// One source for when background jobs run. apps/api/src/jobs/scheduled.ts keys
// its handlers on these crons (a test pins them to wrangler.jsonc), and every
// "03:00 UTC" / "nightly" in the UI reads from here. Workers crons are UTC.

/** A once-a-day cron, "M H * * *". */
type DailyCron = `${number} ${number} * * *`;

export const JOB_SCHEDULE = {
  // Ranks a capped batch per night, least recently ranked first (Q66); roles are
  // also ranked on post/edit, so the rest are caught up on later nights.
  rank: { cron: '0 3 * * *', cadence: 'Nightly, automatic' },
  freshness: { cron: '0 4 * * *', cadence: 'Daily, automatic' },
  // No cron until role volume justifies an unattended send (POST /admin/jobs/digest).
  digest: { cron: null, cadence: 'Sent by a curator' },
} as const satisfies Record<string, { cron: DailyCron | null; cadence: string }>;

export type JobName = keyof typeof JOB_SCHEDULE;

/** "0 3 * * *" → "03:00 UTC". */
export function cronTimeLabel(cron: DailyCron): string {
  const [m = '0', h = '0'] = cron.split(' ');
  return `${h.padStart(2, '0')}:${m.padStart(2, '0')} UTC`;
}

/** When the nightly ranking runs, "03:00 UTC". */
export const RANK_TIME_LABEL = cronTimeLabel(JOB_SCHEDULE.rank.cron);
